import { FC, memo } from 'react'

export interface ShieldIconProps {
  className?: string
  color?: string
}

const ShieldIconComponent: FC<ShieldIconProps> = ({
  className = '',
  color = '#CCFF00',
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0.866211 2C0.866211 0.895431 1.76164 0 2.86621 0H21.2662C22.3708 0 23.2662 0.895431 23.2662 2V16.516C23.2662 17.2377 22.8773 17.9035 22.2486 18.2581L13.0486 23.446C12.4388 23.7899 11.6936 23.7899 11.0838 23.446L1.88382 18.2581C1.25512 17.9035 0.866211 17.2377 0.866211 16.516V2Z"
        fill={color}
      />
      <g clipPath="url(#clip0_1149_8388)">
        <path
          d="M4.06628 3.19995V15.0981L15.0519 15.0596C15.8827 15.0596 16.5162 15.2967 17.0143 16.1237C17.0322 16.1537 17.0582 16.1764 17.0777 16.2047C17.7851 17.2433 18.6804 17.6752 19.7495 17.5886C19.9848 17.5694 20.0673 17.4573 20.0638 17.1709L20.0653 15.2945C20.0733 14.9356 19.9759 14.7901 19.6841 14.7969L17.4054 14.8184C17.4054 14.8184 16.085 14.6515 15.4615 13.8018L15.2062 13.4792C14.5942 12.68 13.8488 12.2916 12.975 12.2939C12.0453 12.2962 11.1156 12.2945 10.1858 12.295C8.77596 12.295 7.19274 12.2883 5.78289 12.3018V10.4611C7.82223 10.4696 9.99647 10.4673 12.0363 10.4667C12.373 10.4667 12.6598 10.5856 12.8956 10.8647C13.1159 11.125 13.3492 11.3713 13.5736 11.6283C14.1541 12.2928 14.8585 12.6624 15.6843 12.6749C17.0337 12.6958 18.3836 12.6777 19.7331 12.6856C19.9838 12.6867 20.0688 12.5639 20.0643 12.2979C20.0558 11.7698 20.0618 11.2411 20.0608 10.7124C20.0598 10.2426 20.0543 10.2358 19.6456 10.2358C17.7362 10.2358 15.8267 10.2347 13.9168 10.2358C12.5339 10.2369 12.6968 10.3416 11.7266 9.21637C11.0101 8.38542 10.1688 7.96995 9.12967 8.00448C8.07103 8.03957 6.84253 8.00844 5.78239 8.0175V6.00467H8.5971C8.93183 5.99844 9.20061 6.15014 9.43142 6.43655C9.7037 6.77448 9.96399 7.12825 10.2413 7.45939C10.7623 8.08203 11.3743 8.48052 12.0958 8.48505C14.6452 8.5009 17.1946 8.49127 19.744 8.4992C19.9774 8.49976 20.0683 8.38599 20.0643 8.09278C20.0563 7.49278 20.0613 6.89278 20.0608 6.29278C20.0608 5.72335 20.0498 5.70863 19.6102 5.70863C16.6011 5.70863 13.5915 5.71656 10.5825 5.7058C8.93033 5.70014 9.31302 5.92825 8.14097 4.42089C7.49999 3.59561 6.68715 3.20108 5.78389 3.20108L4.06628 3.19995Z"
          fill="#131820"
        />
      </g>
      <defs>
        <clipPath id="clip0_1149_8388">
          <rect
            width="16"
            height="14.4"
            fill="white"
            transform="translate(4.06628 3.19995)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const ShieldIcon = memo(ShieldIconComponent)
